import React, { useState, Context, ReactElement, Component } from "react";

export interface service_components {
  kind: string;
  items: service_components_type_item[];
}

export interface service_components_type_item {
  service: string;
  totalCount: number;
  normalCount: number;
  componentItems: [
    {
      componentName: string;
      status: string;
    }
  ]
}

const ServiceComponentsContext: Context<[service_components_type_item[], React.Dispatch<React.SetStateAction<service_components_type_item[]>>]> = React.createContext<[service_components_type_item[], React.Dispatch<React.SetStateAction<service_components_type_item[]>>]>([[] as unknown as service_components_type_item[], (_value: any) => { }]);

const ServiceComponentsProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [service_components, set_service_components]: [service_components_type_item[], React.Dispatch<React.SetStateAction<service_components_type_item[]>>] = useState([] as unknown as service_components_type_item[]);
  return (
    <ServiceComponentsContext.Provider value={[service_components, set_service_components]}>
      {props.children}
    </ServiceComponentsContext.Provider>
  )
}

export { ServiceComponentsContext, ServiceComponentsProvider };
